// @flow
import React from 'react'
import { TextField, Select, Checkbox, Box, Heading } from '@medeo/components'
import themeLight from '@medeo/themes'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as fromActions from '../actions'
import Form from '../components/AddPatientForm'
import FormFooter from '../components/AddPatientFormFooter'
import { ThemeProvider } from 'styled-components'
type PatientInfo = {
  given: string,
  family: string,
  address: string,
  postcode: string,
  country: string,
  gender: string,
  birthDate: string,
  email: string,
  phone: string,
  socialSecurityNo: string,
  practitioner: string
}
type DispatchProps = {
  createPatient: PatientInfo => void
}

type Props = DispatchProps

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
`

const EditPatientForm = ({ createPatient, history }: Props) => {
  const onSubmit = e => {
    e.preventDefault()
    const { elements } = e.currentTarget
    const patientInfo = {
      given: elements.namedItem('given').value,
      family: elements.namedItem('family').value,
      address: elements.namedItem('address').value,
      postCode: elements.namedItem('postCode').value,
      city: elements.namedItem('city').value,
      country: elements.namedItem('country').value,
      gender: elements.namedItem('gender').value,
      birthDate: elements.namedItem('birthDate').value,
      email: elements.namedItem('email').value,
      phone: elements.namedItem('phone').value,
      socialSecurityNo: elements.namedItem('socialSecurityNo').value,
      practitioner: elements.namedItem('practitioner').value
    }
    createPatient(patientInfo)
    history.push('/patients/add/step-4')
  }
  return (
    <Form onSubmit={onSubmit} autoComplete="false">
      <Heading size={20}>Informations</Heading>
      <Box>
        <ThemeProvider theme={themeLight}>
          <Grid>
            <TextField label="prénom" name="given" id="given" required />
            <TextField label="nom" name="family" id="family" required />
            <TextField label="adresse" name="address" id="address" required />
            <TextField
              label="code postal"
              name="postCode"
              id="postCode"
              required
            />
            <TextField label="ville" name="city" id="city" required />
            <TextField label="pays" name="country" id="country" required />
            <Select
              label="sexe"
              name="gender"
              id="gender"
              renderOption={option => <option>{JSON.stringify(option)}</option>}
              items={[
                { label: 'masculin', value: 'male' },
                { label: 'feminin', value: 'female' }
              ]}
              required
            />
            <TextField
              label="date de naissance"
              name="birthDate"
              id="birthDate"
              type="date"
              required
            />
            <TextField label="email" name="email" id="email" type="email" />
            <TextField
              label="téléphone"
              name="phone"
              id="phone"
              type="tel"
              pattern="[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}"
            />
            <TextField
              label="numéro de sécurité sociale"
              name="socialSecurityNo"
              id="socialSecurityNo"
              pattern="[1-3][0-9]{2}(0[1-9]|10|[235-9][0-9]|[14][12])(2[AB]|[0-9]{2})[0-9]{6}[0-8][0-9]|9[0-7]"
            />
            <TextField
              label="médecin traitant"
              name="practitioner"
              id="practitioner"
            />
            <FormattedMessage id={'consentGiven'}>
              {label => (
                <Checkbox id="consent" name="consent" label={label} required />
              )}
            </FormattedMessage>
          </Grid>
        </ThemeProvider>
      </Box>
      <Heading size={20}>Contact d'urgence</Heading>
      <Box>
        <ThemeProvider theme={themeLight}>
          <Grid>
            <TextField
              label="prénom"
              name="emergencyGiven"
              id="emergencyGiven"
              required
            />
            <TextField
              label="nom"
              name="emergencyFamily"
              id="emergencyFamily"
              required
            />
            <TextField
              label="téléphone"
              name="emergencyPhone"
              id="emergencyPhone"
              type="tel"
              pattern="[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}"
            />
          </Grid>
        </ThemeProvider>
      </Box>
      <FormFooter previous="/patients" />
    </Form>
  )
}
const mapDispatchToProps = (dispatch: *): DispatchProps =>
  bindActionCreators({ createPatient: fromActions.createPatient }, dispatch)

export default connect(null, mapDispatchToProps)(EditPatientForm)



// WEBPACK FOOTER //
// ./src/Patients/containers/EditPatientForm.js